export const isValidIsbn = (barcode) => {
//   return /^\d{10}$/.test(barcode) || /^\d{13}$/.test(barcode);
  return /^\d{13}$/.test(barcode);
};

// Convert ISBN-10 to ISBN-13
export function isbn10to13(isbn10) {
  if (!isbn10 || isbn10.length !== 10) return null;

  const core = isbn10.substring(0, 9);   // drop old check digit
  const isbn12 = '978' + core;           // add 978 prefix

  let sum = 0;
  for (let i = 0; i < isbn12.length; i++) {
    const digit = parseInt(isbn12[i], 10);
    sum += (i % 2 === 0) ? digit : digit * 3;
  }
  const remainder = sum % 10;
  const checkDigit = remainder === 0 ? 0 : 10 - remainder;

  return isbn12 + checkDigit;
}